var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgResend = function SvgResend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3054 8.9749C12.9916 8.91213 12.615 9.10042 12.5523 9.41423C11.9247 11.9874 9.66525 13.7448 7.02927 13.7448C3.89121 13.7448 1.31799 11.1715 1.31799 8.03347C1.31799 4.8954 3.89121 2.32218 7.02927 2.32218C8.47279 2.32218 9.9163 2.88703 10.9205 3.89121H8.2845C7.97069 3.89121 7.65689 4.14226 7.65689 4.51883C7.65689 4.83264 7.90793 5.14644 8.2845 5.14644H12.1757C12.4895 5.14644 12.8033 4.8954 12.8033 4.51883V0.627615C12.8033 0.313808 12.5523 0 12.1757 0C11.8619 0 11.5481 0.251046 11.5481 0.627615V2.82427C10.2929 1.69456 8.66107 1.06695 6.96651 1.06695C3.13807 1.06695 -1.4771e-08 4.20502 0 8.03347C1.4771e-08 11.8619 3.13807 15 6.96651 15C10.1673 15 12.9288 12.8033 13.7447 9.72803C13.8075 9.41423 13.6192 9.10042 13.3054 8.9749Z",
    fill: "#8FAAFF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/resend.2664b21f.svg";
export { ForwardRef as ReactComponent };